// HEADS UP!!!
// Code copied from marketplace until `api` reliably provides `donationProvidersAvailability`
// https://github.com/joindeed/marketplace/blob/5ee961a3a1591ee108f412860a7a1b351914b3c6/packages/mongoose-models/src/utils/donationProviders.ts

import { DonationProvider } from '@joindeed/calculate-fees';

import type Organization from 'entities/organization/model';
import { NonprofitIdentifierType } from 'generated/graphql';

type Nonprofit = Pick<
  Organization,
  'ein' | 'externalId' | 'identifiers' | 'locationObject' | 'payPalModel' | 'stripe'
>;

export const isPotentiallyDonatableViaNfg = (nonprofit: Organization) => {
  const hasNcesIdentifier =
    nonprofit.ein ||
    nonprofit.identifiers?.some((identifier) => identifier.type === NonprofitIdentifierType.Nces);
  return Boolean(nonprofit.locationObject?.countryCode === 'US' && hasNcesIdentifier);
};

export const isDonatableViaPayPal = (nonprofit: Nonprofit) =>
  Boolean(nonprofit.payPalModel === 'COMMERCE' || nonprofit.externalId?.startsWith('ext-pp-'));

export const defaultProvidersPriority = [
  DonationProvider.PayPal,
  DonationProvider.GlobalGiving,
  DonationProvider.Betterplace,
  DonationProvider.GiveIndia,
  DonationProvider.NFG,
  DonationProvider.Stripe,
  DonationProvider.CAF,
  DonationProvider.DCGF,
] as const;

export const computeDonationProviderForNonprofit = (
  nonprofit: Organization | undefined,
  preferStripe: boolean
): DonationProvider | null => {
  if (!nonprofit) {
    return null;
  }
  const providersPriority = preferStripe
    ? ([DonationProvider.Stripe, ...defaultProvidersPriority] as const)
    : defaultProvidersPriority;

  return providersPriority.find((provider) => nonprofit.donationProviders?.[provider]) || null;
};
